import { render, staticRenderFns } from "./appHome.vue?vue&type=template&id=04c2d57e&scoped=true&"
import script from "./appHome.vue?vue&type=script&lang=js&"
export * from "./appHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c2d57e",
  null
  
)

export default component.exports